import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Login = () => {
  return (
    <>
      <Header />
      <section className="login-section">
        <div className="container text-center">
          <div className="row justify-content-center">


            <div className="col-md-5">
              <h3 className="title">MON COMPTE EXPERT-COMPTABLE</h3>
              <img src="../assets/images/image22.png" alt="Expert Comptable" className="img-fluid" />
              <p className="description">
                Accédez à votre espace dédié pour gérer vos services d'expertise comptable en toute simplicité.
              </p>
              <Link to="/loginexpert" className="btn btn-primary"> 
                 ENTRER 
               </Link>
            </div>


            <div className="col-md-5">
              <h3 className="title">ESPACE CLIENT</h3>
              <img src="../assets/images/image23.png" alt="Espace Client" className="img-fluid" />
              <p className="description">
                Connectez-vous pour accéder à votre espace client et gérer vos informations comptables.
              </p>
              <Link to="/loginuser" className="btn btn-warning">
                ACCÉDER
              </Link>
            </div>

          </div>
        </div>


        <style>{`
        .login-section {
          padding: 80px 0;
          
        }
        
        .title {
          font-weight: bold;
          margin-top: 20px;
        }

        .description {
          font-size: 16px;
          color: #333;
          margin: 15px 0;
        }

        .btn {
          font-size: 18px;
          font-weight: bold;
          padding: 12px 24px;
          margin-top: 15px;
          border-radius: 5px;
          display: inline-block;
          transition: 0.3s;
        }

        .btn-primary {
          background: #2a77ff;
          border: none;
        }

        .btn-primary:hover {
          background: #1d5edb;
        }

        .btn-warning {
          background: #e63946;
          border: none;
          color: white;
        }

        .btn-warning:hover {
          background: #bf2d3a;
        }
      `}</style>
      </section>
      <Footer />
    </>
  );
};

export default Login;
